import Vue from 'vue';

// v-pms.stop="buttonId"  这种显示但是不显示点击事件  
// v-pms="buttonId"  正常隐藏对应id下的权限按钮
Vue.directive('pms', {
    inserted (el, binding) {
        const { value, modifiers } = binding;
        let btns = JSON.parse(sessionStorage.getItem('btns'));
        if (value && btns && !btns.includes(value)) {
            if (modifiers && modifiers.stop) {
                el.style.pointerEvents = "none";
            } else {
                el.style.display = 'none';
            }
        }
    }
})